"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionPageHighchartsOptionsProvider = void 0;
const React = __importStar(require("react"));
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const ProjectHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/highcharts/ProjectHighchartsOptionsProvider");
const RetentionPageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionPageDataProvider");
const lodash_1 = __importDefault(require("lodash"));
const RetentionPageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionPageModelProvider");
const RetentionJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionJSONModel");
const RetentionPageHighchartsOptionsProvider = (props) => {
    const pageDataContext = (0, RetentionPageDataProvider_1.useRetentionPageDataContext)();
    const pageModelContext = (0, RetentionPageModelProvider_1.useRetentionPageModelContext)();
    const urlJSONModel = pageDataContext.stateFns.getURLJSONModel();
    const chartSettingsJSONModel = urlJSONModel.getChartSettingsJSONModel();
    const chartType = chartSettingsJSONModel.getChartType();
    const retentionType = urlJSONModel.getRetentionTypeJSONModel().getType();
    const filterPeriod = chartSettingsJSONModel.getFilterPeriodByRetentionType(retentionType);
    const filterCohortDays = chartSettingsJSONModel.getFilterCohortDays();
    const formModelSerialized = pageModelContext.pageModelStateFns.getFormJSONModel().serialize();
    const urlModelSerialized = urlJSONModel.serialize();
    const highchartsChartStatus = calculateHighchartsChartStatus(formModelSerialized, urlModelSerialized);
    return React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: pageDataContext.state.error, data: pageDataContext.state.data, parameters: {
            chartType: chartType,
            filterPeriod: filterPeriod,
            shouldAddPeriod: false,
            filterCohortDays: filterCohortDays
        }, highchartsOptionsProviderFn: ProjectHighchartsOptionsProvider_1.ProjectHighchartsOptionsProvider.getRetention, chartStatus: highchartsChartStatus }, props.children);
};
exports.RetentionPageHighchartsOptionsProvider = RetentionPageHighchartsOptionsProvider;
const calculateHighchartsChartStatus = (formModel, urlModel) => {
    formModel = RetentionJSONModel_1.RetentionJSONModel.makeModelStateClean(formModel);
    urlModel = RetentionJSONModel_1.RetentionJSONModel.makeModelStateClean(urlModel);
    const formModelEmpty = RetentionJSONModel_1.RetentionJSONModel.isModelEmpty(formModel);
    const urlModelEmpty = RetentionJSONModel_1.RetentionJSONModel.isModelEmpty(urlModel);
    if (urlModelEmpty) {
        return { status: "notLoaded" };
    }
    else {
        const formModelEqualsToURLModel = lodash_1.default.isEqual(formModel, urlModel);
        if (formModelEqualsToURLModel) {
            return { status: "loaded" };
        }
        if (formModelEmpty) {
            return { status: "parametersChangedButEmpty" };
        }
        else {
            return { status: "parametersChanged" };
        }
    }
};
